import React, { useEffect, useState } from 'react';
//import "./style.sass";
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { useHistory } from 'react-router-dom';
import { decodeStorage } from 'functions/storageBase64';

export function SolicitudProceso(props) {

    const EXTERNO = decodeStorage('EXTERNO');

    const {objRespuesta} = props;

    const history = useHistory();

    const handleIrHome = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}home`);
    };

    return (
        <>
            <div className="modalCredito full">
                <div className="contentModal">
                {
                    EXTERNO ? null : <HeaderMobileCredito logo="img/logo-claroshop.png" type="close" />
                }
                    <div className="contenedorGeneral">
                        <div className="sFmobile">
                            <img src="img/paloma_aprobado.svg"></img>

                            {objRespuesta ?
                                <>
                                    {objRespuesta?.leyenda1 && 
                                        <h2 className="tituloFin colorVerde">{objRespuesta?.leyenda1}</h2>
                                    }

                                    {objRespuesta?.leyenda2 && <p className="copyNormal">{objRespuesta?.leyenda2}</p>}
                                </>
                            :null}

                        
                        </div>
                    </div>
                </div>
            </div>
            <div className="boxBtnSolicitar">
                <button className="btnSolicitar" onClick={handleIrHome}>Enterado</button>
            </div>
        </>
    )
}